<template>
	<Modal title="Assets Details" modal-width="full-width">
		<DisabledForm />

		<fieldset class="dt-responsive table-responsive">
			<legend>
				Assets:
				<span style="font-size: 16px">
					(Note: please classify assets in fixed and current). List all assets
					with an individual current market value of N10,000 or above
				</span>
			</legend>

			<Alert />

			<table id="dt-live-domd" class="table table-bordered nowrap">
				<thead>
					<tr>
						<th>Description of Asset</th>
						<th>Location of Asset</th>
						<th>Current Asset value</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="Object.keys(assets).length">
						<tr v-for="asset in assets" :key="'ast_' + asset.id">
							<td style="padding: 0.75rem 0.75rem">
								{{ asset.description }}
							</td>
							<td style="padding: 0.75rem 0.75rem">
								{{ asset.address }}
							</td>
							<td style="padding: 0.75rem 0.75rem">
								{{ asset.value }}
							</td>
							<td style="padding: 0">
								<button
									@click="deleteItem(asset)"
									class="btn btn-danger"
									style="border-radius: 0; height: 47px; width: 100%"
									:disable="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm"
										role="status"
									></span>
									<span v-else>Delete</span>
								</button>
							</td>
						</tr>
					</template>
					<tr>
						<td style="padding: 0">
							<input
								v-model="form.asset_description"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start typing..."
							/>
						</td>
						<td style="padding: 0">
							<input
								v-model="form.asset_location"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start typing..."
							/>
						</td>
						<td style="padding: 0">
							<input
								v-model="form.asset_value"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start typing..."
							/>
						</td>

						<td>
							<button
								@click="saveRecord()"
								class="btn btn-info"
								style="border-radius: 0; width: 100%"
								:disable="isLoading"
							>
								<span
									v-if="isLoading"
									class="spinner-border spinner-border-sm"
									role="status"
								></span>
								<span v-else>Save</span>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</fieldset>
	</Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { EventBus } from "@/utils/event_bus.js";
import Alert from "@/components/Alert.vue";
import { mapGetters, mapActions } from "vuex";
import DisabledForm from "./DisabledForm.vue";
import Swal from "sweetalert2";

export default {
	components: {
		Modal,
		DisabledForm,
		Alert,
	},
	data() {
		return {
			approval_document_file_name: "",
			form: {
				report_id: this.$route.params.formID,
				report_type: "assets",
				report_from: "",
				report_to: "",
				approval_document: "",
				approved_by: "",
				asset_description: "",
				asset_location: "",
				asset_value: "",
			},
		};
	},
	computed: {
		...mapGetters({
			isLoading: "shared/getLoading",
			assets: "form_ec16c/assets",
		}),
	},
	methods: {
		...mapActions({
			addForm: "form_ec16c/addForm",
			deleteFormRecord: "form_ec16c/deleteFormRecord",
			getFormDetails: "form_ec16c/getFormDetails",
		}),

		async saveRecord() {
			await this.addForm(this.form).then((res) => {
				if (res.status_code == 201) {
					this.clearFormInput();
				}
			});
		},

		clearFormInput() {
			this.form.asset_description = "";
			this.form.asset_location = "";
			this.form.asset_value = "";
		},

		getFormItems() {
			let payload = {
				type: this.form.report_type,
				formID: this.$route.params.formID,
			};

			this.getFormDetails(payload);
		},

		deleteItem(item) {
			Swal.fire({
				title: "Delete Record?",
				text: "This action cannot be undone!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#29623c",
				confirmButtonText: "Yes, delete!",
				cancelButtonText: "Cancel",
			}).then((result) => {
				if (result.isConfirmed) {
					this.sendDeleteRequest(item);
				}
			});
		},

		async sendDeleteRequest(item) {
			let payload = {
				report_id: item.party_annual_report_id,
				item_id: item.id,
				report_type: item.report_type,
			};
			await this.deleteFormRecord(payload).then((res) => {
				if (res.status_code == 200) {
					Swal.fire("Deleted!", res.data.message, "success");
				}
			});
		},
	},

	mounted() {
		this.getFormItems();
		EventBus.$on("date-input", this.setDateInput);
		EventBus.$emit("toggle-modal", "show");
	},
};
</script>

<style scoped>
fieldset {
	/* background-color: #eeeeee; */
}

legend {
	background-color: #29623c;
	color: white;
	padding: 5px 10px;
}
.break-text {
	word-wrap: break-word;
	overflow-wrap: break-word;
	white-space: normal;
	padding: 0;
	padding-left: 2px;
	padding-top: 20px;
}
table {
	width: 100%;
	border-collapse: collapse;
}
td {
	height: 50px;
	padding: 0;
}
td > input {
	width: 100%;
	box-sizing: border-box;
	border: none;
	border-radius: 0;
	height: 100%;
}
.swal2-container {
	z-index: 1090 !important;
}

.modal {
	z-index: 1059 !important;
}
</style>
